import { AxiosError } from 'axios';
import { useQuery, UseQueryResult, UseQueryOptions } from '@tanstack/react-query';
import { couponQueryKeys } from '../../../constants/queryKeys/coupon';
import { CouponApiV2 } from '../../../lib/api/coupon/CouponApiV2';

type BrandLinkResponse = Awaited<ReturnType<typeof CouponApiV2.getCouponBrandLinkList>>;

type BrandLinkOption = {
  couponId: number;
  minimumPurchasePrice?: number;
  discountType?: number;
  discountAmount?: number;
  maxDiscountPrice?: number;
  filterOption: Record<string, unknown>;
  pagination: { pageNum: number; pageSize: number };
};

type BrandLinkData = {
  list: Record<string, unknown>[];
  totalCnt: number;
  filterOption: Record<string, unknown>;
  pagination: { pageNum: number; pageSize: number; pages: number; totalCnt: number };
};

export const useCouponBrandLinkQuery = (
  option: BrandLinkOption,
  options?: UseQueryOptions<BrandLinkResponse, AxiosError, BrandLinkData>,
): UseQueryResult<BrandLinkData, AxiosError> => {
  return useQuery(
    couponQueryKeys.couponBrandLink(option.couponId, option),
    () => CouponApiV2.getCouponBrandLinkList(option),
    {
      select: (res: BrandLinkResponse) => {
        const totalCnt = res.data.totalCnt ?? 0;
        return {
          list: res.data.couponBrandLinkList ?? [],
          totalCnt,
          filterOption: option.filterOption,
          pagination: {
            pageNum: option.pagination.pageNum,
            pageSize: option.pagination.pageSize,
            pages: Math.ceil(totalCnt / Math.max(1, option.pagination.pageSize)) || 1,
            totalCnt,
          },
        };
      },
      enabled: !!option.couponId,
      ...options,
    },
  );
};
